<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1973 1.5L13.4736 10.5908C9.62336 11.5763 9.3739 14.0775 9.19043 16.1045C9.03072 17.8759 8.85119 18.9198 7.34766 19.5H1.5V21H7.5C16.2435 21 18 17.844 18 12.75V12.4072L22.4648 1.5H20.8447L16.5645 11.9561C16.065 11.8978 15.3823 11.7389 14.8359 11.2266L18.8174 1.5H17.1973ZM13.585 12.0967C14.4745 13.0927 15.6903 13.3911 16.4883 13.4736C16.3923 16.5561 15.5273 18.9247 9.84082 19.4092C10.4843 18.4372 10.5886 17.2608 10.6816 16.2393C10.8541 14.3523 10.99 12.8407 13.585 12.0967Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
